
import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action, State } from 'vuex-class';

@Component({})
export default class FblLoading extends Vue {
  @Getter getLoading!: boolean;

  // loading 百分比
  loadingPercent = 10;

  /**
 * Func
 */
  // 假loading 每0.1秒隨機加 1 ~ 9，停在90幾 並停止持續事件
  // createLoading() {
  // 	const driver = setInterval(() => {
  // 		if (this.loadingPercent < 90) {
  // 			this.loadingPercent += Math.floor(Math.random() * 9);
  // 		} else {
  // 			clearInterval(driver);
  // 		}
  // 	}, 50);
  // }

  /**
 * Hook
 */
}
